module.exports = {"440203001":"新华街道","440203002":"惠民街道","440203100":"西联镇","440203101":"西河镇","440203102":"龙归镇","440203103":"江湾镇","440203104":"重阳镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440203.json
// module id = 1956
// module chunks = 0